import React, { Component } from 'react'
import isEmpty from 'lodash/isEmpty'
import filter from 'lodash/filter'

import some from 'lodash/some'

class SearchPromotionCategories extends Component {
    render() {
        const { level = 0 } = this.props
        const { selectedPromotions = [], promotionItem } = this.props

        let itemCategories = !!promotionItem && !!promotionItem.categories ? promotionItem.categories : []
        let initiallySelectedCategories = !!promotionItem && !!promotionItem.initiallySelectedCategories ? promotionItem.initiallySelectedCategories : []

        return (
            <div>
                {!isEmpty(this.props.items) ? (
                    Object.keys(this.props.items).map(key => {
                        const item = this.props.items[key]
                        
                        // Note:
                        // Basic rundown on checked items is that an item can not be disabled if it is already checked or
                        // if it was initially checked and is free to be selected again.

                        const isChecked = some(itemCategories, { 'category_id': item.id }) || itemCategories.indexOf(item.id) > -1
                        const isInitialCategory = initiallySelectedCategories.indexOf(item.id) > -1
                        const isDisabled = !isEmpty(filter(selectedPromotions, { categories: [{ category_id: item.id }] }))
                        
                        return [
                            <label className="promotion-category" htmlFor={item.id} key={item.id}>
                                <input type="checkbox" id={item.id} value={item.id}
                                    checked={isChecked}
                                    disabled={(isDisabled && !isChecked && !isInitialCategory) || this.props.updateLoading || this.props.deletionInProgress}
                                    onChange={e => this.props.handleCheckboxCollectionClick('categories', item.id)}
                                />
                                
                                <div className={'selected-item' + (item.level ? ' sub-category' : '')}>
                                    
                                    {/* Have prefixes for sub categories */}
                                    {[...Array(level)].map((l) =>
                                        <font key={'level' + l}>&nbsp;&nbsp;-&nbsp;&nbsp;</font>
                                    )}

                                    <div className="txt">{item.title}</div>
                                    <span className="icon-checkmark delete-category"></span>
                                </div>
                            </label>,

                            !isEmpty(item.categories) ? <SearchPromotionCategories key={'cat-' + item.id}
                                items={item.categories}
                                level={level + 1}
                                selectedPromotions={selectedPromotions}
                                promotionItem={promotionItem}
                                handleCheckboxCollectionClick={this.props.handleCheckboxCollectionClick}
                                updateLoading={this.props.updateLoading}
                                deletionInProgress={this.props.deletionInProgress}
                            /> : null
                        ]
                    })
                ) : (
                    <div>No Results</div>
                )}
            </div>
        )
    }
}

export default SearchPromotionCategories



// WEBPACK FOOTER //
// ./src/components/search/SearchPromotionCategories.js